import React, { useEffect } from 'react';
import $ from 'jquery';
import nurseImg from '../img/nurse.jpg';
import nurse1Img from '../img/nurse1.jpg';
import { WOW } from 'wowjs/dist/wow.min.js';
import JointCommission from './JointCommission';

function Home() {

    useEffect(() => {
        //$(document).on('ready', function() {


            /* ==================================================
                # Wow Init
             ===============================================*/
            var wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated', // animation css class (default is animated)
                offset: 0, // distance to the element when triggering the animation (default is 0)
                mobile: true, // trigger animations on mobile devices (default is true)
                live: true // act on asynchronously loaded content (default is true)
            });
            wow.init();
            

            /* ==================================================
                # Smooth Scroll
             ===============================================*/
            $("body").scrollspy({
                target: ".navbar-collapse",
                offset: 200
            });

    
            /* ==================================================
                # Banner Animation
            ===============================================*/
            function doAnimations(elems) {
                //Cache the animationend event in a variable
                var animEndEv = 'webkitAnimationEnd animationend';
                elems.each(function() {
                    var $this = $(this),
                        $animationType = $this.data('animation');
                    $this.addClass($animationType).one(animEndEv, function() {
                        $this.removeClass($animationType);
                    });
                });
            }
    
            //Variables on page load
            var $immortalCarousel = $('.animate_text'),
                $firstAnimatingElems = $immortalCarousel.find('.item:first').find("[data-animation ^= 'animated']");
            //Initialize carousel
            $immortalCarousel.carousel();
            //Animate captions in first slide on page load
            doAnimations($firstAnimatingElems);
            //Other slides to be animated on carousel slide event
            $immortalCarousel.on('slide.bs.carousel', function(e) {
                var $animatingElems = $(e.relatedTarget).find("[data-animation ^= 'animated']");
                doAnimations($animatingElems);
            });
    
             /* ==================================================
                # Fun Factor Init
            ===============================================*/
            $('.timer').countTo();
            $('.fun-fact').appear(function() {
                $('.timer').countTo();
            }, {
                accY: -100
            });

    
            /* ==================================================
                Nice Select Init
             ===============================================*/
            /* TODO: REVISE. converts select into dropdown. Code currently commented out */
           /* $('select').niceSelect();*/
    
    
            /* ==================================================
                Contact Form Validations
            ================================================== */
            $('.contact-form').each(function() {
                var formInstance = $(this);
                formInstance.submit(function() {
    
                    var action = $(this).attr('action');
    
                    $("#message").slideUp(750, function() {
                        $('#message').hide();
    
                        $('#submit')
                            .after('<img src="assets/img/ajax-loader.gif" className="loader" />')
                            .attr('disabled', 'disabled');
    
                        $.post(action, {
                                name: $('#name').val(),
                                email: $('#email').val(),
                                phone: $('#phone').val(),
                                comments: $('#comments').val()
                            },
                            function(data) {
                                document.getElementById('message').innerHTML = data;
                                $('#message').slideDown('slow');
                                $('.contact-form img.loader').fadeOut('slow', function() {
                                    $(this).remove()
                                });
                                $('#submit').removeAttr('disabled');
                            }
                        );
                    });
                    return false;
                });
            });
    
        //});
    });

  return (
    <>
      <div className="banner-area shape">
        <div id="bootcarousel" className="carousel text-light text-large slide carousel-fade animate_text" data-ride="carousel">

            <div className="carousel-inner text-center carousel-zoom">
                <div className="carousel-item active">
                    <div className="slider-thumb bg-cover" style={{backgroundImage: `url(${nurseImg})`}}></div>
                    <div className="box-table shadow dark">
                        <div className="box-cell">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1">
                                        <div className="content mt-3">
                                        	<ul data-animation="animated slideInLeft">
                                            	<li>Efficiency</li>
                                            	<li>Reliability</li> 
                                            </ul>
                                            <h2 data-animation="animated slideInDown">Meet the <strong>Best Healthcare Providers</strong></h2>
                                            <a data-animation="animated fadeInUp" className="btn btn-md btn-gradient" href="careers">Discover More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="carousel-item">
                    <div className="slider-thumb bg-cover" style={{backgroundImage: `url(${nurse1Img})`}}></div>
                    <div className="box-table shadow dark">
                        <div className="box-cell">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1">
                                        <div className="content mt-3">
                                        	<ul data-animation="animated slideInLeft">
                                            	<li>Quality</li>
                                            	<li>Compassion</li>
                                            </ul>
                                            <h2 data-animation="animated slideInDown">Why <strong>Choose Us ?</strong></h2>
                                            <a data-animation="animated fadeInUp" className="btn btn-md btn-gradient" href="clients">Discover More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <a className="left carousel-control light" href="#bootcarousel" data-slide="prev">
                <i className="fa fa-angle-left"></i>
                <span className="sr-only">Previous</span>
            </a>
            <a className="right carousel-control light" href="#bootcarousel" data-slide="next">
                <i className="fa fa-angle-right"></i>
                <span className="sr-only">Next</span>
            </a>

        </div>
    </div>

    <div className="about-area features-area default-padding">

        <div className="shape">
            <img src={require("../img/shape/3.svg")} alt="Shape" />
        </div>

        <div className="container-medium">
            <div className="about-items features-item-box">
                <div className="row">
                    <div className="col-lg-5 info">
                        <h5>About Us</h5>
                        <h3>A Great Place to Work. Leading Healthcare Staffing agency in the Triangle.</h3>
                        <JointCommission isHomePage={true} />
                        <p>
                            Divine CHP Staffing a Joint Commission certified staffing agency dedicated to providing efficient, reliable, and compassionate healthcare services to all our clients.
                            <br />
                            We are an approved supplier of permanent, full-time, part-time, per diem, contract healthcare workers including CNAs/Sitters, LPNs, RNs, PA/NPs, MD/DOs and allied health personnel. We assure long term partnership with our clients, valuing efficiency, quality and personalized services to address their healthcare needs. 
                    	 </p>
                    </div>
                    <div className="col-lg-7">
                        <div className="row">

                            <div className="col-lg-6 col-md-6 single-item">
                                <div className="item">
                                    <div className="thumb">
                                        <img src={require("./../img/primarycare.jpg")} alt="Thumb" />
                                    </div>
                                    <div className="content-box">
                                        <div className="info-title">
                                            <i className="flaticon-stethoscope"></i>
                                            <h4><a href="clients">Available Services</a></h4>
                                        </div>
                                    </div>
                                    <div className="info">
                                        <ul>
                                            <li>
                                                <div className="items">
                                                    <span>Nursing (RNs, LPNs, CNAs/Sitters)</span>
                                                    <span>Allied Health</span>
            										<span>Primary Care (PA/NPs, DO/MDs, CRNAs…)</span>
            										<span>Non-Clinical Healthcare</span>
            										<span>Mental Health/Rehab</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 single-item">
                                <div className="item">
                                    <div className="thumb">
                                        <img src={require("./../img/nursecare.jpg")} alt="Thumb" />
                                    </div>
                                    <div className="content-box">
                                        <div className="info-title">
                                            <i className="flaticon-ribbon"></i>
                                            <h4>
                                                <a href="employees">Employees</a>
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="info">
                                        <p>
                                            At Divine CHP Staffing, our teams of highly qualified, carefully vetted care assistants and registered nurses are here to help you whenever you need us, day or night.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="services-area bg-gray default-padding-bottom bottom-less">
        <div className="container">
            <div className="services-items">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        <div className="site-heading text-center">
                            <h4>Services</h4>
                            <h2>Our Departments</h2>
                        </div>
                    </div>
                </div>
                <div className="row">

                    <div className="services-single col-lg-6">
                        <div className="item">
                            <div className="info">
                                <div className="top">
                                    <i className="flaticon-wheelchair"></i>
                                    <strong>01</strong>
                                </div>
                                <h4>
                                    <a href="#">CNAs and Sitters</a>
                                </h4>
                                <p>
                                    At Divine CHP Staffing, our teams of highly qualified nursing assistants/sitters provide excellent and compassionate care to our clients while ensuring their safety. 
                                </p>
                                <ul>
                                    <li>Sitter/Constant Observer</li>
                                    <li>Certified Nursing Assistant in Home or Healthcare Facility</li>
                                </ul>
                               
                            </div>
                        </div>
                    </div>

                    <div className="services-single col-lg-6">
                        <div className="item">
                            <div className="info">
                                <div className="top">
                                    <i className="flaticon-cracked-skin"></i>
                                    <strong>02</strong>
                                </div>
                                <h4>
                                    <a href="#">Nursing</a>
                                </h4>
                                <p>
                                    We believe that mandatory standards for nurse staffing levels and skill mix standards
									would help prevent staffing levels being set too low in the first place, and we will continue
									to campaign for such standards as an important way of guaranteeing patient safety.
                                </p>
                                <ul>
                                    <li>Med/Surg</li>
                                    <li>Telemetry</li>
                                    <li>PACU</li>
                                    <li>ICU</li>
                                    <li>Cardiology</li>
                                    <li>Pediatrics</li>
                                    <li>Oncology</li>
                                    <li>OB/GYN</li>
                                    <li>Rehab</li>
                                    <li>Neurology</li>
                                    <li>Observation</li>
                                    <li>Emergency Room (ER)</li>
                                    <li>Surgery/Trauma</li>
                                </ul>
                               
                            </div>
                        </div>
                    </div>

                    <div className="services-single col-lg-6">
                        <div className="item">
                            <div className="info">
                                <div className="top">
                                    <i className="flaticon-scalpel"></i>
                                    <strong>03</strong>
                                </div>
                                <h4>
                                    <a href="#">Primary Care</a>
                                </h4>
                                <p>
                                    Primary Health Care first seeks to understand and address that gap. Bringing together existing data and recommendations with findings from national research in order to improve health 
                                </p>
                                <ul>
                                    <li>Joints</li>
                                    <li>Spine</li>
                                    <li>Sports Medicine</li>
                                    <li>Bones</li>
                                    <li>Spinal Fusion</li>
                                </ul>
                               
                            </div>
                        </div>
                    </div>

                    <div className="services-single col-lg-6">
                        <div className="item">
                            <div className="info">
                                <div className="top">
                                    <i className="flaticon-coronavirus"></i>
                                    <strong>04</strong>
                                </div>
                                <h4>
                                    <a href="#">Corona Update</a>
                                </h4>
                                <p>
                                    COVID-19 pandemic has become one of the most challenging crises of our generation. Healthcare professionals have been particularly affected by the pandemic while trying to care for their patients, personal health and their love ones. Understanding the COVID-19 disease and ways to prevent and reduce complications risks remain crucial. At Divine CHP Staffing, we strictly follow CDC and local Health Department COVID-19 guidelines. 
                                </p>
                                <ul>
                                    <li>Social Distancing</li>
                                    <li>Masks</li>
                                    <li>CDC guidelines</li>
                                    <li>NC DHHS guidelines</li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    {/*<div className="register-area default-padding bg-fixed shadow half text-light" style="background-image: url(assets/img/bg-3.png);">
        <div className="container">
            <div className="register-items">
                <div className="row align-center">
                    
                    <div className="col-lg-6 form">
                        <div className="appoinment-box">
                            <div className="heading">
                                <h2 id="booking">Make an Appointment</h2>
                            </div>
                            <form action="assets/mail/contactbooking.php" method="POST" className="contact-form">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input className="form-control" id="fname" name="fname" placeholder="First Name" type="text">
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input className="form-control" id="lname" name="lname" placeholder="Last Name" type="text">
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input className="form-control" id="phone" name="phone" placeholder="Phone" type="text">
                                        </div>
                                    </div>
									 <div className="form-group">
                                            <input className="form-control" id="email" name="email" placeholder="Email*" type="email">
                                            <span className="alert-error"></span>
                                        </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input className="form-control" id="date" name="date" placeholder="Appoinment Date" type="text">
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group" >
                                            <select>
                                                <option value="1">Male</option>
                                                <option value="2">Female</option>
                                                <option value="3">Child</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <select>
                                                <option value="1">Department</option>
                                                <option value="2">Medecine</option>
                                                <option value="4">Dental Care</option>
                                                <option value="5">Traumatology</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group comments">
                                            <textarea className="form-control" id="comments" name="comments" placeholder="Briefly state your problem *"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <button type="submit" name="submit" id="submit">
                                            Submit Query <i className="fa fa-paper-plane"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-6 info">
                        <h5>Free Consultation</h5>
                        <h2>Get An Appointment For Get Release.</h2>
                        <p>
                            Departure so attention pronounce satisfied daughters am. But shy tedious pressed studied opinion entered windows off. Advantage dependent suspicion convinced provision him yet. Timed balls match at by rooms we. Fat not boy neat left had with past here call. Court nay merit few nor party learn.
                        </p>
                        <div className="steps">
                            <ul>
                                <li>
                                    <i className="flaticon-calendar-1"></i>
                                    <h5>Appointment</h5>
                                </li>
                                <li>
                                    <i className="flaticon-doctor"></i>
                                    <h5>Select Nurses</h5>
                                </li>
                                <li>
                                    <i className="flaticon-heartbeat"></i>
                                    <h5>Consultation</h5>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>*/}
    </>
  );
}

export default Home;